import { useEffect, useState } from 'preact/hooks'

/**
 * Gets the resource target for the search image
 * @param {string} redirect - The redirect URL
 * @returns {string} The resource target
 */
function getResourceTarget(redirect) {
  const resource = redirect.split('/').pop()
  const strippedResource = resource.split('?')[0]
  // Switch to determine the resource target
  switch (true) {
    case redirect.includes('collections'):
      return `/collections/${strippedResource}?view=img`
    case redirect.includes('products'):
      return `/products/${strippedResource}?view=img`
    case redirect.includes('pages'):
      return `/pages/${strippedResource}?view=img`
    default:
      return null
  }
}

/**
 * @typedef {Object} ResourceImage
 * @property {string} resourceImage - The collection image
 * @property {boolean} isLoading - A boolean indicating if the image is loading
 */

/**
 * Fetches a collection image from the Shopify API
 * @param {string} redirect - The redirect URL
 * @returns {ResourceImage} An object containing the collection image and a boolean indicating if the image is loading
 */
export function useSearchImage(redirect) {
  const [resourceImage, setResourceImage] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(async () => {
    if (!redirect) {
      if (resourceImage) {
        setResourceImage(null)
      }
      return
    }
    setIsLoading(true)
    try {
      const resourceTarget = getResourceTarget(redirect)
      if (!resourceTarget) return
      const imageSrc = await fetch(resourceTarget)
      const image = await imageSrc.text()
      setResourceImage(image.trim())
    } catch (error) {
      setResourceImage(null)
      console.error('Error fetching collection image', error)
    }
    setIsLoading(false)
  }, [redirect])

  return { resourceImage, isLoading }
}
